// src/modules/app-views/crm/pages/Kanban/actions/newOpportunityButton.js
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { UserAddOutlined } from '@ant-design/icons';
import { fromAppStore } from 'stores/app';
import showKanbanQuickAddModal from '../modals/NewOpportunityModal';
import showNewOpportunityFormModal from '../modals/NewOpportunityFormModal';

// *******************************************************************************
// ACTION BUTTON
// *******************************************************************************
const crmKanbanNewOpportunityButton = () => {
  return {
    action: 'new',
    label: 'new_opportunity',
    tooltip: 'new_opportunity',
    icon: <UserAddOutlined />,
    type: 'primary',
    disabled: false,
    visible: true,

    onClick: () => {
      // Extract boardUid from the current URL (routing endpoint: /board/:boardUid)
      const urlMatch = window.location.pathname.match(/\/board\/([^/]+)/);
      const boardUid = urlMatch?.[1];

      // Find the initial column of this board from parameters
      const boards = fromAppStore(s => s.parameters?.modules?.crm?.boards) || [];
      const board = boards.find(b => b.uid === boardUid);
      const sortedColumns = [...(board?.columns || [])].sort(
        (a, b) => (a.order || 0) - (b.order || 0),
      );
      const initialColumn = sortedColumns.find(c => c.initial) || sortedColumns[0] || null;
      const columnUid = initialColumn?.uid || null;

      // Route to custom form modal or standard multi-step modal based on board config
      if (board?.newOpportunityMode === 'custom' && board?.formFields?.length > 0) {
        showNewOpportunityFormModal({ boardUid, columnUid });
      } else {
        showKanbanQuickAddModal({ boardUid, columnUid });
      }
    },

    dropdownItems: [],
  };
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default crmKanbanNewOpportunityButton;
